import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
};
export function Countdown({
  className = ''
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hrs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['sec', seconds % 60]];
  return <div className={`inline-flex items-center gap-2 ${className}`} aria-label="Time remaining on this offer" data-id="element-227" data-mp="1jhk9yn6s8agq">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-228" data-mp="1teg9i3epdm95" data-mpi={index}>
          {index > 0 && <span className="font-display text-3xl font-extrabold text-electric" data-id="element-229" data-mp="1tddmi6ki43yi">:</span>}
          <span className="flex min-w-[76px] flex-col items-center rounded-xl bg-gold px-3 py-3 leading-none shadow-glow-gold" data-id="element-230" data-mp="38ufdd2haew3l">
            <b className="font-display text-4xl font-extrabold tabular-nums tracking-tight text-navy" data-id="element-231" data-mp="34t24skmt8esz">
              {String(value).padStart(2, '0')}
            </b>
            <small className="mt-1 text-[10px] font-bold uppercase tracking-wider text-navy" data-id="element-232" data-mp="2h5yrkh0iidh4">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}